import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function TermsOfServicePage() {
  const navigate = useNavigate();
  const { t } = useTranslation(['common']);

  const sections = [
    {
      title: '一、特别提示',
      content: [
        '欢迎使用CJJY（以下简称"本平台"）提供的相关服务。',
        '请您在使用本平台服务前仔细阅读并充分理解本协议的全部内容。当您完成注册程序或以任何方式使用本平台服务时，即视为您已阅读并同意接受本协议的约束。如果您不同意本协议的任何内容，请立即停止注册或使用本平台服务。',
        '本平台有权根据业务需要或法律法规变化随时修改本协议，修改后的协议将在平台公示，公示期满后生效。如您继续使用本平台服务，即视为您已接受修改后的协议。',
      ],
    },
    {
      title: '二、服务概述',
      content: [
        '本平台为用户提供黄金相关商品的信息展示、价格查询、预订锁价、订单管理及相关配套服务。具体服务内容以本平台实际提供为准。',
        '本平台仅作为信息及交易服务平台，不直接从事黄金生产、销售或投资顾问业务。用户与黄金商家之间的具体交易行为由双方自行约定并承担相应责任。',
        '本平台不对黄金市场价格波动、商品品质争议或交易盈亏承担任何担保或赔偿责任。',
      ],
    },
    {
      title: '三、用户注册',
      content: [
        '用户在使用本平台部分功能前需完成注册，注册时需提供真实、准确、完整的个人信息。用户同意并保证：提供的注册信息真实有效，且会及时更新以保持准确性；不使用他人身份信息进行注册；不注册多个账号进行恶意操作。',
        '用户应妥善保管账号及密码，因用户保管不善导致的账号被盗、信息泄露或财产损失，由用户自行承担。如发现账号异常，应立即联系本平台客服。',
        '本平台有权根据法律法规要求或安全需要对用户身份进行核验，用户应予以配合。',
      ],
    },
    {
      title: '四、服务使用规范',
      content: [
        '用户在使用本平台服务时应遵守中华人民共和国法律法规及相关规定，不得利用本平台从事任何违法违规活动，包括但不限于：发布虚假、欺诈信息；从事洗钱、非法集资等金融犯罪活动；干扰或破坏本平台正常运行；侵犯他人知识产权或其他合法权益；从事任何可能损害本平台或第三方利益的行为。',
        '用户应按照本平台规定的流程进行操作，因用户未按流程操作导致的损失由用户自行承担。',
      ],
    },
    {
      title: '五、锁价与订单',
      content: [
        '本平台提供的锁价功能仅表示用户在特定时间点锁定了参考价格，实际交易以最终订单确认为准。',
        '用户提交订单后，应按照订单约定及时完成支付或其他必要操作。因用户原因导致订单无法完成的，本平台及合作商家有权按照相关规则处理。',
        '订单取消、退款、修改等操作应按照本平台公布的规则执行。特殊商品或服务可能不支持取消或退款，具体以页面提示为准。',
      ],
    },
    {
      title: '六、支付与结算',
      content: [
        '用户应按照订单金额及时完成支付。本平台支持多种支付方式，具体以页面展示为准。',
        '用户应确保使用的支付账户为本人合法持有，因支付账户问题导致的交易失败或资金损失由用户自行承担。',
        '涉及退款时，本平台将按照原支付路径退回，具体到账时间以银行或支付机构处理时间为准。',
      ],
    },
    {
      title: '七、风险提示',
      content: [
        '黄金价格受国际市场影响，波动较大。用户应充分了解黄金交易的市场风险，根据自身风险承受能力谨慎决策。',
        '本平台提供的价格信息仅供参考，实际交易价格以订单确认时为准。',
        '用户应自行承担因市场波动、政策变化、不可抗力等因素导致的交易风险及损失。',
      ],
    },
    {
      title: '八、知识产权',
      content: [
        '本平台上的所有内容，包括但不限于文字、图片、标识、商标、软件、代码等，均受知识产权法律法规保护。未经本平台书面许可，任何单位或个人不得以任何方式使用、复制、修改或传播上述内容。',
        '用户在本平台发布的内容，用户应保证拥有合法权利，且不侵犯第三方权益。用户授予本平台非独占、免费、可转授权的权利，以使用、复制、修改、发布该等内容用于提供服务。',
      ],
    },
    {
      title: '九、责任限制',
      content: [
        '在法律允许的最大范围内，本平台不对因下列原因导致的服务中断、数据丢失或其他损失承担责任：不可抗力因素；计算机病毒、黑客攻击等网络安全事件；用户自身原因；第三方服务提供商的故障；法律法规变化或政府行为。',
        '本平台对用户通过本平台与第三方达成的交易不承担担保责任，交易纠纷由用户与第三方自行解决。',
      ],
    },
    {
      title: '十、协议终止',
      content: [
        '用户可随时申请注销账号终止本协议。账号注销后，用户将无法继续使用本平台服务，但本平台仍有权依法保存必要的信息。',
        '如用户违反本协议约定，本平台有权暂停或终止向用户提供服务，并保留追究法律责任的权利。',
      ],
    },
    {
      title: '十一、争议解决',
      content: [
        '本协议的订立、执行和解释均适用中华人民共和国法律（不含冲突法规则）。',
        '如双方就本协议内容或其执行发生争议，应尽量友好协商解决；协商不成的，任何一方均可向本平台运营主体所在地有管辖权的人民法院提起诉讼。',
      ],
    },
    {
      title: '十二、其他',
      content: [
        '本协议构成双方就服务使用的完整协议，取代此前任何形式的口头或书面约定。',
        '如本协议任何条款被认定为无效或不可执行，不影响其他条款的效力。',
        '本平台未行使或执行本协议任何权利或规定，不构成对该权利或规定的放弃。',
        'CJJY 网站：jacmarket.cn',
        '版本：V1.0 更新日期：2026年8月11日',
      ],
    },
  ];

  return (
    <div className="min-h-screen bg-brown-50">
      {/* Header */}
      <div className="bg-brown-950 px-4 py-3 flex items-center sticky top-0 z-10">
        <button
          onClick={() => navigate(-1)}
          className="w-8 h-8 flex items-center justify-center text-gold-400 cursor-pointer"
        >
          <i className="ri-arrow-left-line text-lg"></i>
        </button>
        <h1 className="text-gold-400 text-lg font-bold flex-1 text-center pr-8">
          {t('common:userServiceAgreement')}
        </h1>
      </div>

      {/* Content */}
      <div className="px-4 py-6 pb-12 max-w-2xl mx-auto">
        <div className="bg-white rounded-xl p-5 md:p-8">
          <h2 className="text-xl font-bold text-brown-900 mb-1">CJJY用户服务协议</h2>
          <p className="text-xs text-brown-500 mb-6">版本号 V1.0 · 更新日期 2026年8月11日</p>

          <div className="space-y-6">
            {sections.map((section) => (
              <div key={section.title}>
                <h3 className="text-sm font-bold text-brown-900 mb-2">{section.title}</h3>
                <div className="space-y-2">
                  {section.content.map((paragraph, idx) => (
                    <p key={idx} className="text-sm text-brown-600 leading-relaxed">
                      {paragraph}
                    </p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}